/**
 * External Dependencies
 */
import initMenu from './initMenu';
import switchTheme from './switchTheme';
import projectsSlider from './projectsSlider';
import storiesSlider from './storiesSlider';
import projectsShowcase from './projectsShowcase';
import teamSlider from './teamSlider';
import galleryWithLightbox from './galleryWithLightbox';
import dynamicQuote from './dynamicQuote';
import progressWidth from './progressWidth';
import readingTime from './readingTime';
import tabs from './tabs';

/* $(() => {
}); */
window.initMenu = initMenu
window.switchTheme = switchTheme
window.projectsSlider = projectsSlider;
window.storiesSlider = storiesSlider;
window.projectsShowcase = projectsShowcase;
window.teamSlider = teamSlider;
window.galleryWithLightbox = galleryWithLightbox;
window.dynamicQuote = dynamicQuote
window.progressWidth = progressWidth
window.readingTime = readingTime
window.tabs = tabs
